import { render } from "./Offline.vue?vue&type=template&id=562a3295"
import script from "./Offline.vue?vue&type=script&setup=true&lang=js"
export * from "./Offline.vue?vue&type=script&setup=true&lang=js"

import "./Offline.vue?vue&type=style&index=0&id=562a3295&lang=scss"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UI/modals/Offline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "562a3295"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('562a3295', __exports__)) {
    api.reload('562a3295', __exports__)
  }
  
  module.hot.accept("./Offline.vue?vue&type=template&id=562a3295", () => {
    api.rerender('562a3295', render)
  })

}


export default __exports__